// @flow

import Decimal from 'decimal.js';

const convertBottlesToQty = (Bottles: number, Uom: number = 1) => {
  return new Decimal(Bottles / Uom).toDecimalPlaces(5, 1).toNumber();
};

export { convertBottlesToQty };
